import React from "react";
import { scrollToSection } from "../../../../app/useScrollToSection";
import {
	USAGE_LESSONS,
	USAGE_REVIEWS_GIVEN,
	USAGE_REVIEWS_RECEIVED,
	USAGE_WRITING_CR,
	USAGE_WRITING_ESSAY,
} from "./UsageReport";

interface SummaryTableProps {
	className?: string;
	summary: {
		essayCount: number;
		draftCount: number;
		averageDraftPerEssayCount: number;
	};
	constructedResponseSummary: {
		essayCount: number;
		draftCount: number;
		averageDraftPerEssayCount: number;
	};
	peerReviewsGiven: any[];
	peerReviewsReceived: any[];
	tutorialUsageForCourse: {
		timeSpentString: string;
	};
}

export function SummaryTable({
	className = "",
	summary,
	constructedResponseSummary,
	peerReviewsGiven,
	peerReviewsReceived,
	tutorialUsageForCourse,
}: SummaryTableProps) {
	return (
		<table className={`tbl-usage ${className}`}>
			<colgroup>
				<col className="mr-4" />
				<col className="w-28 mr-12" />
				<col />
				<col className="w-28" />
			</colgroup>
			<tbody>
				<tr>
					<th className="link" onClick={() => scrollToSection(USAGE_WRITING_ESSAY)}>
						Number of Essays
					</th>
					<td>{summary.essayCount}</td>
					<th className="link" onClick={() => scrollToSection(USAGE_WRITING_CR)}>
						Constructed Response Essays
					</th>
					<td>{constructedResponseSummary.essayCount}</td>
				</tr>
				<tr>
					<th>Number of Drafts</th>
					<td>{summary.draftCount}</td>
					<th>Constructed Response Drafts</th>
					<td>{constructedResponseSummary.draftCount}</td>
				</tr>
				<tr>
					<th>Drafts Per Essay</th>
					<td>{summary.averageDraftPerEssayCount}</td>
					<th>Drafts Per Constructed Response</th>
					<td>{constructedResponseSummary.averageDraftPerEssayCount}</td>
				</tr>
				<tr className="tbl-usage-section">
					<th className="link" onClick={() => scrollToSection(USAGE_REVIEWS_GIVEN)}>
						Peer Reviews Given
					</th>
					<td>{peerReviewsGiven.length}</td>
					<th className="link" onClick={() => scrollToSection(USAGE_REVIEWS_RECEIVED)}>
						Peer Reviews Received
					</th>
					<td>{peerReviewsReceived.length}</td>
				</tr>
				<tr className="tbl-usage-section">
					<th className="link" onClick={() => scrollToSection(USAGE_LESSONS)}>
						Lesson Usage
					</th>
					<td>{tutorialUsageForCourse.timeSpentString}</td>
					<th></th>
					<td></td>
				</tr>
			</tbody>
		</table>
	);
}
